import React,{useState,useEffect} from 'react'
import style from './Check.module.css';
import axios from 'axios';

const Check =()=> {
  const [phoneNumber,setPhoneNumber] = useState('');
  const [message , setMessage] = useState('');
  const base_url = process.env.REACT_APP_BASE_URL;

  const checkPhoneNumber = async ()=>{
    if(phoneNumber.length!=10){
        setMessage("Enter valid 10 digit Number");
        return ;
    }
   try {
      const resp = await axios.post(`${base_url}/user/check`,{
        phoneNumber : phoneNumber
      },{
        headers: {
            "Content-Type":"application/json"
        }
      });
    //   console.log(resp);
      // console.log(resp.data);  
      setMessage(resp.data.message);
   } catch (error) {
     console.log(error);
   }
  }

  return (
    <div className={style.maindiv}>
        <h2>Enter the Phone Number</h2>
        <p>Enter the user's phone number here to check wheather the user is whitelisted or not!</p>

        <div className={style.subdiv}>
            <label htmlFor='phoneNum'>User's Phone Number</label>
            <input type='tel' id='phoneNum' value={phoneNumber} onChange={(e)=>{setPhoneNumber(e.target.value)}} />
            <button onClick={()=>{checkPhoneNumber()}}>Check</button>
            <p>{message}</p>
        </div>
    </div>
  )
}

export default Check